module.exports = __webpack_public_path__ + "defaultImg-7b5bb5278f4795cc1fcdfb9676c16a54.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/house/defaultImg.svg
// module id = 203
// module chunks = 0 1 2